export const GATags = {
  CODB: 'G-M96KKGQHYR',
  AI_ACADEMY: 'G-DHV5JF0GXK',
  DORA_ASSESSMENT: 'G-Z0ZLW0QPSM',
  FLASH_SUSTAINABILITY: 'G-2S01PW49YS',
  LEADERSHIP_ASSESSMENT: 'G-BZ5PZD00N8',
  CLOUD_PAK_NETWORK: 'G-F90WTYJZS7',
  CLOUD_PAK_AIOPS: 'G-9RCY094CKM',
  RAI_ASSESSMENT: 'G-TVPCQCV9W9',
  ROI_CALCULATOR_BANKING: 'G-Y7PTT3G3SQ',
  ROI_CALCULATOR_GOV: 'G-HZW1SB91HB',
  ROI_CALCULATOR_TELCO: 'G-BZ3JNWZ0MG',
  ROI_CALCULATOR_UTILITIES: 'G-FV9FJGBYKC',
};
